/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GraphNodeDto
 */
export interface GraphNodeDto {
    /**
     * 
     * @type {string}
     * @memberof GraphNodeDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GraphNodeDto
     */
    type: string | null;
    /**
     * 
     * @type {string}
     * @memberof GraphNodeDto
     */
    label: string | null;
    /**
     * 
     * @type {{ [key: string]: any | null; }}
     * @memberof GraphNodeDto
     */
    data?: { [key: string]: any | null; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof GraphNodeDto
     */
    isOrphan?: boolean;
}

/**
 * Check if a given object implements the GraphNodeDto interface.
 */
export function instanceOfGraphNodeDto(value: object): value is GraphNodeDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function GraphNodeDtoFromJSON(json: any): GraphNodeDto {
    return GraphNodeDtoFromJSONTyped(json, false);
}

export function GraphNodeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GraphNodeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'label': json['label'],
        'data': json['data'] == null ? undefined : json['data'],
        'isOrphan': json['isOrphan'] == null ? undefined : json['isOrphan'],
    };
}

export function GraphNodeDtoToJSON(json: any): GraphNodeDto {
    return GraphNodeDtoToJSONTyped(json, false);
}

export function GraphNodeDtoToJSONTyped(value?: GraphNodeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'label': value['label'],
        'data': value['data'],
        'isOrphan': value['isOrphan'],
    };
}

